import React from "react";
import { Checkbox } from "react-materialize";
import { useInfo } from "context/InfoContext";

export default function TableHead({ handleEvents }) {
  const { filters } = useInfo();
  const data = [
    "Notification Type",
    "TO/CC/BCC",
    "Country",
    "Department",
    "Sales Office",
    "Agent Code",
  ];
  let list = [];
  for (const i in data) {
    let detail = "";
    list.push(
      <th key={"col-" + i} className={"th-" + data[i].toLocaleLowerCase()}>
        {data[i]}
        {detail}
      </th>
    );
  }
  list.push(
    <th key={"col-" + data.length} className={"th-remove"}>
      <Checkbox
        checked={filters?.checkedAllRemove ?? false}
        filledIn
        id={"checkbox-remove-items"}
        name=""
        className={"checkbox-remove-item"}
        label={"Bulk Remove"}
        value={"all"}
        onChange={handleEvents.OnChange}
      />
    </th>
  );
  /*list.push(<th key={"col-" + (data.length)} className="th-bulk-action">
        <BtnAction 
            setActionData={setActionData} 
            actionData={actionData} 
            active_page={active_page}
            userSess={userSess} />
    </th>);*/
  return (
    <thead key="recip-table-head">
      <tr key="recip-table-row-0">{list}</tr>
    </thead>
  );
}
